import { AnimatePresence, motion } from 'motion/react';
import { useState } from 'react';

import { EditFilterForm } from './EditFilterForm';
import { ModalCloseButton } from './ModalCloseButton';
import { PageHeader } from './PageHeader';
import { QueryPreview } from './QueryPreview';

import { LogicalOperator, type SavedQuery, type SavedQueryBody } from '@/entities/query/types';

interface QueryBuilderModalProps {
  isOpen: boolean;
  onClose?: () => void;
  unmount: () => void;
  savedQuery: SavedQuery;
  workspaceId: string;
}

export function QueryFilterEditModal({
  isOpen,
  onClose,
  savedQuery,
  workspaceId,
}: QueryBuilderModalProps) {
  const [currentFilter, setCurrentFilter] = useState<SavedQueryBody>({
    filter: {
      include:
        savedQuery.filter.include.length > 0
          ? savedQuery.filter.include
          : [{ op: LogicalOperator.Or, values: [] }],
      exclude: savedQuery.filter.exclude,
    },
    options: savedQuery.options,
  });

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="h-[90vh] w-full max-w-[1200px] overflow-hidden rounded-lg bg-white shadow-sm"
          >
            <div className="flex h-full flex-col">
              <PageHeader
                className="p-6"
                title={`Edit filter for ${savedQuery.name}`}
                description="Build the content to be included and excluded in your query."
                right={<ModalCloseButton className="z-10" onClick={onClose} />}
              />
              <div className="h-[1px] w-full bg-zinc-300" />
              <div className="relative flex flex-1 overflow-scroll">
                <EditFilterForm filterForm={currentFilter} onChange={setCurrentFilter} />
                <div className="h-full w-[1px] bg-zinc-300" />
                <QueryPreview
                  savedQuery={savedQuery}
                  currentPaylaod={currentFilter}
                  workspaceId={workspaceId}
                  onClose={onClose}
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
